const LS_KEY = "comfyviz_active_workspace";

export function getActiveWorkspace(): string {
  return localStorage.getItem(LS_KEY) ?? "";
}

export function setActiveWorkspace(id: string): void {
  localStorage.setItem(LS_KEY, id);
}
